import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import './App.css'
import { createBrowserRouter, RouterProvider, Routes, Route } from 'react-router-dom'
import axios from 'axios'
import { apiPath } from './apiPath'

import {useCreateEngine, EngineProvider} from './Engine'
import Connecting from './components/Connecting'
import Messages from './components/Messages'
import NotFound from './components/NotFound'
import Header from './components/Header'

import Home from './pages/Home'
import Profile from './pages/Profile'
import LoginPage from './pages/LoginPage'
import Map from './pages/Map'
import Models from './models/Models'
import { Container } from 'react-bootstrap'
import {QueryClient, QueryClientProvider } from 'react-query'
import FormFillPage from './pages/FormFillPage'

// Processes
import AddSeminar from './processes/Seminar'
import AddConference from './processes/Conference'
import ManageSeminars from './processes/Seminars'
import ManageConferences from './processes/Conferences'
import ProcessVisits from './processes/Visits'
import ProcessVisit from './processes/Visit'
import ProcessVisitsList from './processes/VisitsList'
import ProcessRoomAssignmentsList from './processes/RoomAssignmentsList'
import ManageRoomLabels from './processes/RoomLabels'
import SanityCheck from './processes/SanityCheck'
import ChangeRoom from './processes/ChangeRoom'
import AddCourse from './processes/Course'
import ManageCourses from './processes/Courses'
import Document from './processes/Document'
import ManageTimesheets from './processes/Timesheets'
import EditTimesheetMonth from './processes/TimesheetMonth'

const BASE_URL = (process.env.REACT_APP_SERVER_URL || "").replace(/\/+$/, '')

console.log("dm-manager (app starting)")

const queryClient = new QueryClient({
  defaultOptions: {
      queries: {
          queryFn: async ({queryKey}) => {
              const path = []
              let params = {}
              for (const key of queryKey) {
                  if (typeof key === 'object') {
                      params = key
                      break
                  }
                  path.push(key)
              }
              const out = await axios.get(BASE_URL + apiPath(...path), {params})
              return out.data
          },
        keepPreviousData: true,
      }
  }
})

function Internal() {
  const engine = useCreateEngine()
  
  if (! engine.connected) {
    return <Connecting engine={engine}/>
  }

  const publicRoutes = [
    '/pub/fill/',  
    '/process/document/'
  ]

  const isPublicRoute = () => {
    const path = window.location.pathname
    return publicRoutes.some(route => path.startsWith(route))
  }
  
  if (! engine.loggedIn && !isPublicRoute()) {
    return <EngineProvider value={engine}>
        <Messages messages={ engine.messages } acknowledge={ () => engine.clearMessages() } />
        <Container fluid>
          <Routes>  
            <Route path={`/pub/fill/:id`} element={<FormFillPage />} />
            <Route path="*" element={<LoginPage engine={engine} />} />
          </Routes>
        </Container>
    </EngineProvider>
  }

  return <EngineProvider value={engine}>
      {engine.loggedIn && <Header/>}
      <Messages messages={ engine.messages } acknowledge={ () => engine.clearMessages() } />
      <Container fluid className="pt-5 p-lg-5 main-container">
        <Routes>
          {/* Public routes */}
          <Route path={`/pub/fill/:id`} element={<FormFillPage />} />
          <Route path="/process/document/:id" element={<Document />} />
          
          {/* Protected routes - only rendered if logged in */}
          {engine.loggedIn && <>
            <Route path="/" element={<Home />} />
            <Route path="/profile" element={<Profile />} />

            <Route path="/process/seminars" element={<ManageSeminars/>}/>
            <Route path="/process/seminars/add" element={<AddSeminar/>}/>
            <Route path="/process/seminars/add/:id" element={<AddSeminar/>}/>

            <Route path="/process/conferences" element={<ManageConferences/>}/>
            <Route path="/process/conferences/add" element={<AddConference/>}/>
            <Route path="/process/conferences/add/:id" element={<AddConference/>}/>

            <Route path="/process/my/visits" element={<ProcessVisits variant="my/"/>}/>
            <Route path="/process/my/visits/:id" element={<ProcessVisit variant="my/"/>}/>
            <Route path="/process/visits" element={<ProcessVisits variant=""/>}/>
            <Route path="/process/visits/:id" element={<ProcessVisit variant=""/>}/>
            <Route path="/process/visitsList" element={<ProcessVisitsList variant=""/>}/>
            
            <Route path="/process/roomAssignmentsList" element={<ProcessRoomAssignmentsList variant=""/>}/>

            <Route path="/process/roomLabels" element={<ManageRoomLabels/>}/>

            <Route path="/process/sanityCheck" element={<SanityCheck/>}/>
            <Route path="/process/changeRoom" element={<ChangeRoom/>}/>
            
            <Route path="/process/my/courses" element={<ManageCourses variant="my/"/>}/>
            <Route path="/process/courses/add" element={<AddCourse variant="my/"/>}/>
            <Route path="/process/my/courses/add/:id" element={<AddCourse variant="my/"/>}/>
            <Route path="/process/courses" element={<ManageCourses variant=""/>}/>
            <Route path="/process/courses/add" element={<AddCourse variant=""/>}/>
            <Route path="/process/courses/add/:id" element={<AddCourse variant=""/>}/>

            <Route path="/process/timesheets" element={<ManageTimesheets/>}/>
            <Route path="/process/timesheets/:timesheetId" element={<ManageTimesheets/>}/>
            <Route path="/process/timesheets/:timesheetId/:year/:month" element={<EditTimesheetMonth/>}/>
           
            <Route path="/process/document/:id" element={<Document />} />
            
            { Object.values(Models).map(x => x.routers()) }
            
            <Route path="/map" element={<Map />} />
          </>}
          
          <Route path="*" element={engine.loggedIn ? <NotFound /> : <LoginPage engine={engine} />} />
     </Routes>
    </Container>
 </EngineProvider>
}  

// A data router allows forms to block internal navigation with useBlocker.
const router = createBrowserRouter([{ path: '*', element: <Internal /> }])

export default function App() {
  return <QueryClientProvider client={queryClient}>
    <RouterProvider router={router} />
  </QueryClientProvider>    
}
